export const words = {
  place: "Ubicación",
  yes: "Sí",
  no: "No",
  new: "Nuevo",
  agb: 'AGB',
  agb_full: "Condiciones generales",
  datenschutzerklaerung: "Política de privacidad",
  status: "Estado",
  company_name: "Nombre de la empresa",
  next_button: "Más información en",
  device_name: "Nombre del dispositivo",
  to_connect: "Conectar",
  pin: 'PIN',
  time: "Tiempo",
  first_name: "Nombre",
  last_name: "Apellido",
  code: "Código",
  help: "Ayuda",
  total_time: "Tiempo total",
  latitude: "Latitud",
  longitude: "Longitud",
  accuracy: "Precisión",
  timestamp: "Marca de tiempo",
  device_id: "ID del dispositivo",
  active: "activo",
  o_clock: "h",
  loading: "Tienda",
  annotation: "Nota",
  since: "desde",
  camera: "Cámara",
  map: "Mapa",
  gallery: "Galería",
  work: "Trabajo",
  employees: "Empleados",
  login: "Inscripción",
  login_action: "Conectarse",
  calendar_week_abbreviation: 'KW',
  calendar: "Calendario",
  to_call: "Llame a",
  email: "Correo electrónico",
  attachment: "Anexo",
  operational_planning: "Plan operativo",
  to_scan: "Escanear",
  download: "Descargar",
  export: "Exportar",
  to_document: "Documento",
  checklist: "Lista de control",
  checklists: "Listas de control",
  password: "Contraseña",
  confirmation: "Confirmación",
  confirm: "Confirme",
  confirmation_email: "Correo electrónico de confirmación",
  unknown: "Desconocido",
  unknown_place: "Ubicación desconocida",
  unknown_plan: "Horario de turnos sin nombre",
  project_no: "Proyecto n",
  project_file: "Archivo del proyecto",
  contact_person: "Póngase en contacto con",
  overtime: "Horas extraordinarias",
  timesheet: "Horario",
  minustime: "Menos horas",
  back: "Volver",
  undo: "Deshacer",
  clockout: "Eliminar",
  clocked_out: "estampado",
  clockin: "Sello en",
  clocked_in: "estampado",
  dismiss: "Cancelar",
  discard: "Rechazar",
  finish: "Listo",
  or: "o",
  copy: "Copiar",
  qr_code: "Código QR",
  documentation: "Registro del tiempo y documentación",
  attendance: "Terminal de tableta",
  tiercontent: "Alcance del paquete",
  start_now: "Empezar ahora",
  skip: "omitir",
  logout_during_core_time: "Estampado durante el horario central",
  absent_during_core_time: "Ausente durante el tiempo central",
  distance: "Distancia",
  km_reading: "Kilometraje",
  the_start: "Inicio",
  the_end: "Fin",
  license_plate: "Matrícula",
  details: "detalles",
  hide: "ocultar",
  cost: "Costes",
  file: "Archivo",
  address_book: "Agenda",
  template_plural: "Plantillas",
  signature: "Firma",
  main_project: "Proyecto principal",
  main_projects: "Principales proyectos",
  sub_projects: "Subproyectos",
  scan_to_login_header: "Registro con código QR",
  description: "Descripción",
  project_location: "Ubicación del proyecto",
  phone_number: "Número de teléfono",
  project_info: "Información sobre el proyecto",
  number_short: "No.",
  sketch: "Boceto",
  video: "Vídeo",
  delete: "Borrar",
  send: "Enviar",
  sending: "Enviar...",
  save: "Guardar",
  granted: "aprobado",
  pending: "solicitado",
  denied: "Rechazado",
  customer: "Cliente",
  mobile_number: "Número de teléfono",
  ok: 'Ok',
  day: "Día",
  tomorrow: "Mañana",
  days: "Días | Día | Días",
  holidays: "Vacaciones",
  vacation_days: "Vacaciones",
  vacation_hours: "Horario de vacaciones",
  request: "Solicitar",
  accept: "Acepte",
  withdraw: "Retirar",
  hour_account: "Cuenta horaria",
  period: "Periodo",
  to: "a",
  date: "Cita previa",
  number: "Número",
  message: "Mensaje",
  change: "cambiar",
  changed: "Cambiado",
  changed_fields: "Cambio de campo",
  type: "Arte",
  hour: "Hora",
  hours: "Horas",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Horas",
  end: "fin",
  end_date: "Plazo",
  start_date: "Fecha de inicio",
  absence: "Ausencia",
  month: "mes",
  week: "Semana",
  transcript: "Transcripción",
  time_left: "restante",
  transcript_tasks: "Tareas",
  add_task: "Nuevo",
  /** Differentiation in some languages (e.g. English) */
  from: "de",
  of: "de",
  of_hours: "desde {hours} horas",
  of_hours_abbreviation: "{hours} de horas.",
  /**************/

  used: "usado",
  update: "Actualización",
  today: "hoy",
  correction: "Corrección",
  work_time: "Tiempo de trabajo",
  break: "Pausa",
  loading_time: "Tiempo de carga",
  driving_time: "Duración del viaje",
  business_trip: "Turno de servicio",
  project: "Proyecto",
  special_one: "Especial1",
  special_two: "Especial2",
  clock: "h",
  search: "Buscar en",
  operation: "Actividad",
  day_protocol: "Protocolo diario",
  continue: "más",
  total_duration: "Tiempo total",
  duration: "Duración",
  hello: "Hola",
  close: "cerrar",
  comment: "Comentario",
  small: "pequeño",
  medium: "medio",
  large: "grande",
  sharpie: "Pin",
  line: "Línea",
  arrow: "Flecha",
  rectangle: "Rectángulo",
  ellipse: "Elipse",
  text: "Texto",
  language_settings: "Ajustes de idioma",
  clock_reminder: "Recordatorio de sello",
  individually: "Individual",
  from_o_clock: "de",
  to_o_clock: "a",
  eraser: "Borrador",
  edit: "Editar",
  legal_notes: "Legal",
  notes: "Notas",
  note: "Nota",
  imprint: "Pie de imprenta",
  open_source_licenses: "Condiciones de la licencia de código abierto",
  author: 'Autor',
  license_type: "Tipo de licencia",
  version: "Versión",
  substitute: "Representación",
  not_rated: "Sin clasificar",
  weekly_working_hours: "Horas de trabajo semanales",
  show_less: "Mostrar menos",
  office_center: "Centro de oficinas",
  admin_view: "Gestión NFC",
  register: "Registro",
  shifts: {
    shift_attachments: "Accesorios (capa)",
    shift_plan_attachments: "Accesorios (plan de turnos)",
    shift_plan: "Horario de turnos",
    shift: "Capa"
  },
  absences: {
    sick: "Enfermedad (continuación del pago del salario)",
    vacation: "Vacaciones",
    workshop: "Seminario/Curso",
    special_vacation: "Licencia especial",
    school: "Escuela",
    working_time_account: "Cuenta de tiempo de trabajo",
    holiday: "Vacaciones",
    other: "Otros",
    driving_time: "Duración del viaje",
    parental_leave: "Permiso parental",
    excused_absent: "Ausente justificado (remunerado)",
    not_excused_absent: "Ausencia sin excusa",
    sick_industrial_accident: "Enfermedad Accidente laboral (LFZ)",
    short_time_work: "Trabajo a jornada reducida (Kug)",
    maternity_pay: "Protección de la maternidad Prohibición de empleo/salario",
    sick_child: "Cuidar a un niño enfermo con paga (diaria) por enfermedad",
    sick_child_no_payment: "Cuidado de un hijo enfermo sin subsidio (diario) de enfermedad",
    vacation_no_payment: "Permiso no retribuido",
    sick_before_short_time_work: "Subsidio de enfermedad/enfermedad antes del Kug",
    weather_related_failure: "Fallo debido a las condiciones meteorológicas",
    sick_short_time_work: "Enfermedad durante el Kug",
    sick_no_payment: "Enfermedad (sin continuación del pago del salario)",
    company_vacation: "Vacaciones en la empresa",
    meals_14_euro: "Pequeño subsidio de restauración",
    meals_28_euro: "Gran asignación para catering"
  },
  image_editor: {
    font_size: "Tamaño de letra",
    stroke_width: "Anchura de línea",
    stroke_color: "Color de línea",
    text_color: "Color de fuente",
    rotate_left: "Gire a la izquierda",
    rotate_right: "Gire a la derecha",
    flip_horizontal: "Espejo horizontal",
    flip_vertical: "Espejo vertical"
  },
  travel_log: {
    method_of_transportation: "Medios de transporte",
    company_car: "Coche de empresa",
    private_car: "Coche privado",
    rental_car: "Coche de alquiler",
    taxi: 'Taxi',
    public_transportation: "Transporte público",
    airplane: "Avión",
    train: "Ferrocarril (transporte público de larga distancia)",
    other: "Otros",
    km_reading_start: "Inicio de kilometraje",
    km_reading_end: "Kilometraje final",
    net_expenses: "Gastos de viaje (netos)",
    tax: "Impuesto sobre el valor añadido"
  },
  read_in: "Leer en",
  currency: "Moneda",
  reason: "Razón",
  label: "Etiqueta",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
  break_alarm: "Romper el despertador",
  clockin_reminder: "Recordatorio de fichar",
  clockout_reminder: "Recordatorio de cancelación"
};